import { createAppTheme } from './create-app-theme';

export { createAppTheme };

export const lightTheme = createAppTheme('light');
export const darkTheme = createAppTheme('dark');